export default __webpack_public_path__ + "static/Catupiry-2df067d06eb71d1bdf6b11826bc314b6.png";